import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async salvar ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `subprocessodespacho/salvar`
    })
    return data
  },

  async finalizar ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `subprocessodespacho/finalizar`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/subProcessoDespacho.js